import Vue from "vue";
import Vuex from "vuex";
import state from './state'
import mutations from './mutations'
import * as getters from './getters'
import * as actions from './actions'
Vue.use(Vuex);

import {
  createFlashStore
} from 'vuex-flash';

// import { createFlashStore } from 'vuex-flash';


export default new Vuex.Store({
  state:state,
  mutations:mutations,
  actions:actions,
  getters:getters,
  plugins: [
    createFlashStore()
  ]
});
